export default {
    container: {
        px: { xs: 2, sm: 6 },
        mx: 'auto',
        maxWidth: '1440px',
        position: 'relative',
    }
}